// src/hooks/useGlobalLoader.ts
import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { selectShowLoader } from '@/store/selectors/ui';
import { setShowLoader, setHideLoader } from '@/store/slices/ui/uiSlice';

export function useGlobalLoader() {
  const dispatch = useAppDispatch();
  const show = useAppSelector(selectShowLoader);

  const showLoader = useCallback(() => dispatch(setShowLoader()), [dispatch]);
  const hideLoader = useCallback(() => dispatch(setHideLoader()), [dispatch]);

  return {
    state: { show },
    handlers: { showLoader, hideLoader },
  };
}
